import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cfb3dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "focus-wrapper",
    onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.focused = true)),
    onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.$emit('click')), ["enter"])),
    "aria-label": _ctx.altText ? 'Select if ' + _ctx.altText : 'Image Label',
    role: "button"
  }, [
    _createElementVNode("div", {
      id: `image-label-${_ctx.id}`,
      class: "image-label-container",
      style: _normalizeStyle(_ctx.containerCSS),
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hovered = true)),
      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hovered = false)),
      onMousedown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = true)),
      onMouseup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.active = false)),
      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.focused = false)),
      "aria-hidden": "true"
    }, [
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.image,
            alt: _ctx.altText ?? _ctx.image
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "image-label-background",
        style: _normalizeStyle(_ctx.backgroundCSS),
        "aria-hidden": "true"
      }, null, 4),
      _createElementVNode("div", {
        class: "image-label-text",
        style: _normalizeStyle(_ctx.textCSS)
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 4)
    ], 44, _hoisted_2)
  ], 40, _hoisted_1))
}